import { useContext } from 'react';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
import { attemptToConvertExternalOptionsFilter, isOperatorIncompatibleWithExternalOptionsField } from '../utils/externalOptionsConversionUtils';
import { useStrategy } from './useStrategy';
import { useOperatorOptions } from './useOperatorOptions';
import { ObjectTypeIdRegex } from '../filterQueryFormat/ObjectTypeId';
export const useConditionInputs = props => {
  const {
    condition,
    disabled,
    filterFamily,
    onConditionOperatorChange,
    onConditionValueChange,
    isRefinement = false,
    isRefinementEnabled = false
  } = props;
  const {
    getOperatorsForType,
    isRequiredConditionForEvent
  } = useStrategy();
  const {
    getIsUngated,
    getTrackerInstance,
    props: {
      baseFilterFamily,
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    options: operatorOptions,
    getOperatorByName
  } = useOperatorOptions(filterFamily, condition === null || condition === void 0 ? void 0 : condition.field, condition);
  const isOperatorIncompatible = !!condition && isOperatorIncompatibleWithExternalOptionsField(condition, filterFamily, getOperatorsForType, getIsUngated);
  const canFilterBeConverted = isOperatorIncompatible && attemptToConvertExternalOptionsFilter(condition) !== undefined;
  const isRefinementDisabled = isRefinement && !isRefinementEnabled;
  const disableOperatorSelection = disabled || isOperatorIncompatible || isRefinementDisabled || !!condition && isRequiredConditionForEvent(filterFamily, condition);
  const disableValueInput = disabled || isRefinementDisabled;
  const onSelectedOptionChange = evt => {
    var _condition$field, _getTrackerInstance, _condition$field2;
    const operatorName = evt.target.value.value;
    onConditionOperatorChange(getOperatorByName(operatorName));
    const propertyOrFilterFamily = ObjectTypeIdRegex.test(baseFilterFamily) ? condition === null || condition === void 0 || (_condition$field = condition.field) === null || _condition$field === void 0 ? void 0 : _condition$field.name : baseFilterFamily;
    (_getTrackerInstance = getTrackerInstance()) === null || _getTrackerInstance === void 0 || _getTrackerInstance.track('changedFilterOperator', {
      operator: operatorName,
      primaryObjectTypeId: baseFilterFamily,
      property: propertyOrFilterFamily,
      type: condition === null || condition === void 0 || (_condition$field2 = condition.field) === null || _condition$field2 === void 0 ? void 0 : _condition$field2.type,
      version: useOnePanel ? '2' : '1'
    });
  };
  const handleUpdateClick = () => {
    if (!(condition !== null && condition !== void 0 && condition.field)) {
      return;
    }
    const newCondition = attemptToConvertExternalOptionsFilter(condition);
    if (newCondition) {
      onConditionValueChange(newCondition);
    }
  };
  return {
    canFilterBeConverted,
    disableOperatorSelection,
    disableValueInput,
    handleUpdateClick,
    isOperatorIncompatible,
    onSelectedOptionChange,
    operatorOptions
  };
};